import { render, staticRenderFns } from "./role.vue?vue&type=template&id=3690e6dc&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&id=3690e6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690e6dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3690e6dc')) {
      api.createRecord('3690e6dc', component.options)
    } else {
      api.reload('3690e6dc', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=3690e6dc&scoped=true&", function () {
      api.rerender('3690e6dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/role.vue"
export default component.exports